import axios from "axios";
import {Base_URL} from "../url"

export const fetchCostCenterOfficeMappings = async () => {
  try {
    const response = await axios.get(`${Base_URL}/CostCenterOfficeMapping/GetAllMappings`);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching cost center office mappings!";
  }
};

export const downloadMappingsExcel = async () => {
  try {
    const response = await axios.post(
      `${Base_URL}/CostCenterOfficeMapping/DownloadMappingsExcel`,
      null, // Empty body for POST request
      {
        responseType: 'blob',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        }
      }
    );
    return response;
  } catch (error) {
    throw error.response?.data || "Error downloading mappings data!";
  }
};